module.exports = __webpack_public_path__ + "static/media/n_icon_kefu@2x.50100d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_kefu@2x.png
// module id = 1808
// module chunks = 0 1